export default {
  title: 'Complete Website Specifications and Laptop Reviews No. 1 in Indonesia',
  description: 'A website that reviews products, especially laptops, in a complete and in-depth manner. You can find a laptop of your choice according to the specifications you choose.',
};
